import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import Switch from '@/components/FormElements/Switch';
import { communityHasMemberModeration } from '@/scenes/Management/Community/utils';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfileSettingsAugmented } from '@/store/user/selectors/selectActiveProfileSettingsAugmented';
import { updateProfileSetting } from '@/store/user/thunks/updateProfileSetting';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export function ModerationSettings() {
  const dispatch = useDispatch();
  const { activeProfileId } = useActiveProfile();
  const settings = useSelector(state =>
    selectActiveProfileSettingsAugmented(state, { activeProfileId })
  );
  const [membersModeration, setMembersModeration] = useState(
    communityHasMemberModeration(settings)
  );
  const [token] = useTokenState();

  const handleMemberModerationChange = e => {
    if (
      membersModeration &&
      !window.confirm(
        'При выключении премодерации все активные запросы будут автоматически одобрены. Продолжить?'
      )
    ) {
      return;
    }
    setMembersModeration(!membersModeration);
    dispatch(
      updateProfileSetting(
        'community.joinRequest',
        e.target.checked ? 'approve' : 'auto',
        token
      )
    );
  };

  return (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Модерация</h4>
          <p>Вы можете включить или выключить модерацию сообщества</p>
        </SettingSectionTitle>
        <Settings>
          <Switch
            testId="new-profile-community-switcher"
            label="премодерация участников"
            checked={membersModeration}
            onClick={handleMemberModerationChange}
          />
        </Settings>
      </SettingsFlexbox>
    </Block>
  );
}
